export function setAccessTokenCookie(token: string, exp: number) {
    const expirationTime = Date.now() + exp * 1000

    // Set the cookie with the expiration time
    const expires = new Date(expirationTime).toUTCString()
    document.cookie = `access_token=${token}; expires=${expires}; path=/; Secure; SameSite=Strict`
}
